import Vue from 'vue'
import App from './App.vue'
import router from './router';
import "./assets/css/reset.less"
import "./assets/css/style.less"
import './assets/theme/index.css';
Vue.config.productionTip = false
import store from './store';
import http from './utils/http';


import {
  Menu,
  Submenu,
  MenuItem,
  Select,
  Option,
  Input,
  Button,
  Carousel,
  CarouselItem,
  Form,
  FormItem,
  Dialog,
  Loading,
  Tabs,
  TabPane,
  Tag,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Pagination,
  Image,
  Radio,
  Table,
  TableColumn,
  Message,
  Progress,
  Row,
  Col,
  Tooltip,
  Divider,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Popover,
  Slider,
  Link,
  Popconfirm,
  RadioGroup,
  Cascader,
  ButtonGroup,
} from "element-ui"

Vue.use(Menu);
Vue.use(Cascader);
Vue.use(RadioGroup);
Vue.use(Popconfirm);
Vue.use(ButtonGroup);
Vue.use(Link);
Vue.use(Slider);
Vue.use(Popover);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Divider);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Button);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Pagination);
Vue.use(Image);
Vue.use(Radio);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Progress);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tooltip);

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
Vue.prototype.$http = http;
Vue.prototype.$message = Message;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
